import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ShowErrorComponent } from '../show-error/show-error.component';
import { NgClass } from '@angular/common';
import { IconComponent } from '../../icon/icon.component';
import { debounceTime, first } from 'rxjs/operators';

@Component({
  selector: 'fnsr-input-field',
  standalone: true,
  imports: [ShowErrorComponent, NgClass, ReactiveFormsModule, IconComponent],
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss']
})
export class InputFieldComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() id = '';
  @Input() type = 'text';
  @Input() text = '';;
  @Input() name = '';;
  @Input() value = '';
  @Input() path = '';;
  @Input() required: boolean = false;
  @Input() highlightChanges: boolean = false;

  private originalValue: any;

ngOnInit(): void {
    if (this.formGroup && this.path) {
      // Warten, bis das erste echte API-Value ins Formular geladen wird
      this.formGroup.get(this.path)?.valueChanges
        .pipe(debounceTime(300), first()) // Debounce verhindert doppelte Aufrufe
        .subscribe(value => {
          this.originalValue = value; // Originalwert speichern, wenn API geladen ist
        });
    }
  }

  isFieldChanged(): boolean {
    return this.highlightChanges && this.formGroup.get(this.path)?.value !== this.originalValue;
  }
}
